




































import Modal from "../../core/Modals/Modal.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Intervention } from "../../models/Intervention";

export default {
    name: "InterventionSetupEdit",
    components: { EmployeSelect, Modal },
    props: {
        interventions: Array,
    },
    data() {
        return {
            showModal: true,
            saving: false,
            selectedEmployes: [],
            InterventionApi: new InterventionApi(),
        };
    },
    methods: {
        closeModal: function (): void {
            this.$emit("close-modal");
        },
        saveData: function (): void {
            let self = this;
            let promises = [];

            if (self.saving) {
                return;
            }

            self.saving = true;

            _.forEach(self.interventions, function (src) {
                let source = new Intervention(src);
                let names = _.map(source.employes, function (e) {
                    return e.prenom + " " + e.nom;
                }).join(", ");
                let setup = new Intervention({
                    client_id: source.client_id,
                    date_prevue_intervention: source.date_prevue_intervention,
                    horaire_debut: source.horaire_debut,
                    duree_prevue: 0.5,
                    mise_en_place: true,
                    titre: names ? "Mise en place de " + names : "Mise en place",
                });
                setup.updateHoraireFin();
                setup.employes = self.selectedEmployes;
                promises.push(self.InterventionApi.save(setup));
            });
            Promise.all(promises).then(function () {
                self.closeModal();
            });
        },
    },
};
